import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IFunding } from '@publishing-engine/domain/models';
import { Badge, Table } from '@morressier/alembic';

type IProps = {
  value: IFunding[];
  exists: string;
};

export const FundingGenericDisplay: React.FC<IProps> = ({ value, exists }) => (
  <Flex flexDirection={'column'}>
    {
      <Text textStyle="textBody" my={2}>
        {exists}
      </Text>
    }
    {
      <Table>
        {value?.length > 0 && (
          <Table.HeaderRow
            display="flex"
            alignItems="center"
            data-cy="grant-table-header"
          >
            <Table.HeaderCell flex={1}>Funder</Table.HeaderCell>
            <Table.HeaderCell flex={1}>Grant or Award Numbers</Table.HeaderCell>
          </Table.HeaderRow>
        )}

        <Table.Body sx={{ borderTop: 'none' }}>
          {value?.map(funding => (
            <Table.Row key={funding.grantNumber} gap={4} alignItems="baseline">
              <Table.RowCell flex="1" textStyle="headingItem" textAlign="left">
                <Flex flex={1} textStyle="textBody">
                  {funding.fundingBody}
                </Flex>
              </Table.RowCell>
              <Table.RowCell flex="1" textStyle="headingItem" textAlign="left">
                <Flex flex={2} gap={2} alignItems="flex-start" flexWrap="wrap">
                  {funding.grantNumber ? (
                    funding.grantNumber.split(',').map((value, index) => (
                      <Flex key={index}>
                        <Badge style={{ whiteSpace: 'break-spaces' }}>
                          <Text textStyle="headingItem">{value}</Text>
                        </Badge>
                      </Flex>
                    ))
                  ) : (
                    <Text textStyle="textBody" color="GrayText">
                      No data available
                    </Text>
                  )}
                </Flex>
              </Table.RowCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    }
  </Flex>
);
